<script>
  import { useQuery } from "@sveltestack/svelte-query";
  import superagent from "superagent";

  const storedUser = localStorage.getItem("user");
  let env;
  let user =
    storedUser !== null
      ? JSON.parse(storedUser)
      : {
          name: "(ditt navn)",
          surname: "",
        };
  const currentUser = useQuery("me", () =>
    user.id !== undefined
      ? superagent
          .get("/api/me")
          .set("Authorization", "Bearer " + user.id)
          .then((response) => {
            env = response.headers.environment;
            return response.body;
          })
      : superagent.get("/api/me").end((err, response) => {
          env = response.headers.environment;
        })
  );

  $: if (!$currentUser.isLoading && $currentUser.data && user !== undefined) {
    user = $currentUser.data;
    localStorage.setItem("user", JSON.stringify(user));
  }
</script>

{#if env && env !== "production"}
  <svg
    width="100%"
    height="25px"
    xmlns="http://www.w3.org/2000/svg"
    style="background-color: red; color:white"
  >
    <defs>
      <pattern
        id="basicPattern"
        patternUnits="userSpaceOnUse"
        width="50"
        height="25"
      >
        <text
          x="10"
          y="5"
          font-size="20"
          fill="white"
          alignment-baseline="hanging"
          >{(env ?? "test").replace("no_gdpr", "*")}</text
        >
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#basicPattern)" />
  </svg>
{/if}
